import React from "react"
import Input from "./UI/Input"
import ToolBarFilterButton from "./Filters/ToolBarFilterButton"

const FilterToolBar = React.forwardRef((props, ref) => {
  const {
    handleChange,
    UIButtons,
    currentOption,
    filterButtonsOpen,
    reset,
    changeButton,
  } = props

  const toolbarButtons = UIButtons.map((button, index) => (
    <ToolBarFilterButton
      onClick={() => {
        changeButton(button.filter)
      }}
      id={`button${index}`}
      key={`button${index}`}
      text={button.text}
      currentOption={currentOption}
      filter={button.filter}
      filterButtonsOpen={filterButtonsOpen}
    />
  ))

  return (
    <section
      id="toolbar"
      className="filter-buttons tw-py-2 tw-mb-12 md:tw-space-x-12 tw-flex tw-flex-col md:tw-flex-row tw-space-y-4 md:tw-space-y-0 sm:tw-items-end tw-items-start tw-justify-center"
    >
      <form
        onSubmit={handleChange}
        className="tw-mt-1 sm:tw-mr-auto tw-flex tw-justify-start"
        style={{ marginBottom: 0 }}
      >
        <Input
          searchButton
          id="search"
          style={{ marginBottom: 0 }}
          type="text"
          placeholder="Search Degrees"
        />
      </form>
      <p>
        <strong>Filter by:</strong>
      </p>
      {toolbarButtons}
      <button
        onClick={reset}
        id="button4"
        style={{ paddingBottom: 0 }}
        className="tw-bg-white tw-border-0 focus:tw-outline-none"
      >
        <strong>Clear Filters</strong>
      </button>
    </section>
  )
})

export default FilterToolBar
